export interface AgentVoiceStatusResponse {
  success: boolean;
  voice_agent_enabled: boolean;
  has_elevenlabs_agent: boolean;
  elevenlabs_agent_id?: string;
  agent_name?: string;
  error_message?: string;
}

export async function getAgentVoiceStatus(
  agentPublicId: string,
  apiUrl: string
): Promise<AgentVoiceStatusResponse> {
  const url = `${apiUrl}/api/v1/agent/public/${agentPublicId}/info`;
  
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => {
      return { response_message: 'Network error occurred' };
    });
    throw new Error(error.response_message || 'Unable to load voice assistant');
  }

  const result = await response.json();
  
  if (!result.success) {
    throw new Error(result.response_message || 'Unable to load voice assistant configuration');
  }
  
  const data = result.agent_info;
  if (!data) {
    throw new Error('Voice assistant not found');
  }
  
  return {
    success: true,
    voice_agent_enabled: data.voiceAgentEnabled || false,
    has_elevenlabs_agent: Boolean(data.elevenlabsAgentId),
    elevenlabs_agent_id: data.elevenlabsAgentId,
    agent_name: data.name,
    error_message: undefined,
  } as AgentVoiceStatusResponse;
}
